import {MathUtil} from 'common/util/MathUtil';

export class PriceUtil {
    private static readonly currencies: {[iso: string]: {symbol: string, position: string}} = {
        'CAD': {symbol: '$', position: 'before'},
        'EUR': {symbol: '€', position: 'after'},
        'USD': {symbol: '$', position: 'before'}
    };

    public static applyTaxes(priceTaxExcluded: string, taxRates: number[], decimals: number = 2): string {
        let priceTaxIncluded: number = Number(priceTaxExcluded);
        taxRates.forEach((rate) => {
            priceTaxIncluded += Number(priceTaxExcluded) * rate;
        });

        return String(MathUtil.round(priceTaxIncluded, decimals));
    }

    public static calculateTaxes(priceTaxExcluded: number, taxRates: number[]): number {
        let taxes: number = 0;
        taxRates.forEach((rate) => {
            taxes += priceTaxExcluded * rate;
        });

        return MathUtil.round(taxes, 2);
    }

    public static displayWithCurrency(price: string, isoCurrency: string): string {
        if (price === undefined || price === null) {
            return price;
        }

        const currency: {symbol: string, position: string} = PriceUtil.currencies[isoCurrency];

        let newPrice: string = price + ' ' + isoCurrency;
        if (currency !== undefined) {
            switch (currency.position) {
                case 'before':
                    newPrice = currency.symbol + price;
                    break;
                case 'after':
                    newPrice = price + currency.symbol;
                    break;
            }
        }

        return newPrice;
    }

    public static format(price: string, locale: 'fr' | 'us', decimals: number = 2): string {
        if (price === undefined || price === null) {
            return price;
        }

        const priceNumber: number = Number(price.replace(/\,/gi, ''));
        const standardPrice: string = priceNumber.toLocaleString('en-US', {
            style: 'decimal',
            useGrouping: true,
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });

        switch (locale) {
            case 'fr':
                return standardPrice.replace(/\,/gi, ' ').replace(/\./gi, ',');
            case 'us':
                return standardPrice;
        }
    }

    public static round(price: string, precision: number = 0.10): string {
        const priceInCents: number = Number(price) * 100;
        const precisionInCents: number = precision * 100;
        const rest: number = priceInCents % precisionInCents;

        return String(MathUtil.round((priceInCents - rest) + (rest < Math.ceil(precisionInCents / 2) ? 0 : precisionInCents), 2) / 100);
    }
}
